import { AuthService, ConfigStateService, RestService } from '@abp/ng.core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class LogoutServiceService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private configState: ConfigStateService,
  ) {}

  logout(): Observable<void> {
    const token = this.authService.getAccessToken();
    const clientId = environment.oAuthConfig.clientId; 

    const body = new HttpParams()
      .set('client_id', clientId)
      .set('token', token)
      .set('token_type_hint', 'access_token');

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer ' + this.authService.getAccessToken(),
    });

    localStorage.clear();
    sessionStorage.clear();

    return this.http.post(environment.oAuthConfig.issuer + "connect/revocat", body.toString(), { headers }).pipe(
      map(() => {}),
      catchError((err) => {
        return of();
      })
    );
  }

}
